import * as React from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_timesheet_wizard/AddTimesheetForm.scss';
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import Input from '../../components/Input';
import DateTimePicker from '../../components/DateTimePicker';

const AddCompanyPositionsForm = (props) => {
  const _handleSubmit = (edit) => {
    props.change('edit', edit);

    setTimeout(() => props.submit(), 10);
  };

  const countries = _.map(props.localization.countries, (country) => {
    return {
      value: country.id,
      label: country.name,
    };
  });

  return (
    <Form className={styles.wrapper}>
      <div className={styles.form}>
        <Field
          name='name'
          component={Input}
          label={__('table.columns.company-positions.name')}
          placeholder={__('add-company-positions-form.add-name')}
        />
        <Field
          name='abbreviation'
          component={Input}
          label={__('table.columns.company-positions.abbreviation')}
          placeholder={__('add-company-positions-form.add-abbreviation')}
        />
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={props.actions.hideAddTimesheetWizard}
          />
          <ButtonGroup>
            <Button
              lightBlue
              medium
              middleText={__('button.create')}
              spinning={props.submitting}
              onClick={() => _handleSubmit(false)}
            />
          </ButtonGroup>
        </div>
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    values: getFormValues('add_company_positions.company_positions')(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      hideAddTimesheetWizard: () =>
        dispatch({
          type: 'table.company_positions/SET_TABLE_PARAMS',
          params: {
            wizard_active: undefined,
          },
        }),
    },
  };
};

export default withRouter(
  reduxForm({
    form: 'add_company_positions.company_positions',
  })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(subscribe(Localization, 'localization')(AddCompanyPositionsForm))
  )
);
